/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { crudDe } from "../../../services/acesso";
import api from "../../../services/api";
import { MdCancel } from "react-icons/md";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../../store/hooks";
import { AiOutlineClockCircle } from "react-icons/ai";
import ModalForm from "../../../components/modal-form";
import { TipoFormulario } from "../../../services/constantes";
import Listagem, { ConfiguracaoFiltros, FiltroDropdownOpcao } from "../../../components/listagem";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { obterIdTenent, usuarioTemPermissao } from "../../../services/seguranca";
import { useFiliais } from "../../../hooks/useFiliais";
import ModalGerarLancamentoMulta from "../../../components/modal-gerar-lancamento-multa";
import { converterTipoStatusMultaParaTexto, diaInicialDepoisDoFinal, formatarParaReais, parseDateFromString, tratarErroApi } from "../../../services/utilitarios";
import { FaCarSide, FaCheckDouble, FaEye, FaFileInvoice, FaFileInvoiceDollar, FaMoneyBillWave, FaMotorcycle, FaTimesCircle } from "react-icons/fa";
import { ApiError, Banco, Campo, ContextoMulta, Locacao, Multa, Opcao, TipoStatusMulta } from "../../../services/tipos";
import { toast } from "react-toastify";
import { FiTruck, FiUser } from "react-icons/fi";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";

function MultaListagem() {
    const { empresaTemFiliais, filiaisOptions, filialSelecionada, getCampoFilial, getAcaoEmLoteFilial, labelComFilial } = useFiliais();
    const [multas, setMultas] = useState<Multa[]>([]);
    const [buscar, setBuscar] = useState<boolean>(true);
    const [veiculos, setVeiculos] = useState<Opcao[]>([]);
    const [locatarios, setLocatarios] = useState<Opcao[]>([]);
    // Datas da URL ("YYYY-MM-DD") em hora LOCAL: new Date("YYYY-MM-DD") é meia-noite UTC e, serializada
    // com "Z" para a API, vira 21:00 do dia anterior em Brasília e a lista abria no dia errado.
    const [dataInicio, setDataInicio] = useState<Date | null>(() => {
        const p = new URLSearchParams(window.location.search).get('dataInicio');
        return p ? parseDateFromString(p) : new Date(new Date().getFullYear(), 0, 1);
    });
    const [dataFim, setDataFim] = useState<Date | null>(() => {
        const p = new URLSearchParams(window.location.search).get('dataFim');
        return p ? parseDateFromString(p) : new Date();
    });
    const [statusFiltro, setStatusFiltro] = useState<string>(() => {
        const p = new URLSearchParams(window.location.search).get('status');
        return p ?? String(TipoStatusMulta.Todos);
    });
    const [idVeiculoFiltro, setIdVeiculoFiltro] = useState<string>("");
    const [idLocatarioFiltro, setIdLocatarioFiltro] = useState<string>("");
    const [tipoPeriodo, setTipoPeriodo] = useState<"realizacao" | "pagamento">("realizacao");
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [locacoes, setLocacoes] = useState<Locacao[]>([]);
    const [locacoesOp, setLocacoesOp] = useState<Opcao[]>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [showGerarLancamento, setShowGerarLancamento] = useState(false);
    const [entidadeAtualizacao, setEntidadeAtualizacao] = useState<any>({});
    const [carregandoSelect, setCarregandoSelect] = useState<boolean>(false);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [campoVeiculoAtivo, setCampoVeiculoAtivo] = useState<boolean>(true);
    const [forcarAtualizacao, setForcarAtualizacao] = useState<boolean>(false);
    const [veiculosRaw, setVeiculosRaw] = useState<any[]>([]);
    const [locacoesRaw, setLocacoesRaw] = useState<any[]>([]);
    const [filialNoForm, setFilialNoForm] = useState<string | null>(null);
    const [multaSelecionado, setMultaSelecionado] = useState<Multa>({} as Multa);
    const [id, setId] = useState<string | null>(null);
    const [mostrarAvancadoMulta, setMostrarAvancadoMulta] = useState(false);
    const [bancosMultaOpcoes, setBancosMultaOpcoes] = useState<{ label: string; valor: string }[]>([]);
    const [veiculoMultaAtual, setVeiculoMultaAtual] = useState<string>('');
    const [dataCometimentoAtual, setDataCometimentoAtual] = useState<string>('');
    const autoPreenchendoLocacaoRef = useRef(false);

    const navigate = useHistory();
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get('id');
        const statusParam = searchParams.get('status');
        const dataInicioParam = searchParams.get('dataInicio');
        const dataFimParam = searchParams.get('dataFim');

        if (id) {
            setId(id);
        }
        if (statusParam) {
            setStatusFiltro(statusParam);
        }
        if (dataInicioParam) {
            setDataInicio(parseDateFromString(dataInicioParam));
        }
        if (dataFimParam) {
            setDataFim(parseDateFromString(dataFimParam));
        }
    }, [location.search]);

    useEffect(() => {
        api.get(`/bancoPorEmpresa/${obterIdTenent(token)}?apenasAtivos=true`)
            .then(r => setBancosMultaOpcoes(r.data.map((b: Banco) => ({ label: b.apelido, valor: b.id }))))
            .catch(() => setBancosMultaOpcoes([]));
    }, [token]);


    const colunas = [
        {
            field: 'idVeiculo', headerName: 'Informações', flex: 2,
            renderCell: (params: any) => {
                const locatario = params.row.locacao?.locatario;
                const veiculo = params.row.veiculo;
            
                const getVehicleIcon = () => {
                    switch (Number(veiculo?.tipoVeiculo)) {
                        case 1: return <FaCarSide size={16} />;
                        case 2: return <FaMotorcycle size={16} />;
                        case 3: return <FiTruck size={16} />;
                        default: return <FaCarSide size={16} />;
                    }
                };
            
                const veiculoLabel = veiculo
                    ? `${veiculo.placa}: ${veiculo.marca} ${veiculo.modelo}`
                    : '';
            
                return (
                    <Box display="flex" flexDirection="column" py={0.5}>
                        {/* Locatário - exibe apenas se existir */}
                        {locatario?.documento && (
                            <Box display="flex" alignItems="center" gap={1}>
                                <FiUser size={16} />
                                <Typography variant="body2">{locatario.nome}</Typography>
                            </Box>
                        )}
            
                        {/* Veículo - exibe apenas se existir */}
                        {veiculo && (
                            <Box display="flex" alignItems="center" gap={1} mt={locatario ? 0.5 : 0}>
                                {getVehicleIcon()}
                                <Typography variant="body2">{veiculoLabel}</Typography>
                            </Box>
                        )}
                    </Box>
                );
            },            
            valueGetter: (params: any) => {
                return `${params.row.veiculo.placa} - ${params.row.veiculo.marca} - ${params.row.veiculo.modelo}`;
            },
        },
        { field: 'descricaoInfracao', headerName: 'Descrição', flex: 3 },
        {
            field: 'valor', headerName: 'Valor', flex: 1, renderCell(params: any) {
                return formatarParaReais(params.value);
            }
        },
        {
            field: 'dataHoraCometimento', headerName: 'Data Cometimento', flex: 1,
            valueGetter: (params: any) => {
                return new Date(params.value);
            },
            renderCell: (params: any) => {
                const date = new Date(params.value);
                if (isNaN(date.getTime())) {
                    return '';
                }
                return date.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });
            },
        },
        {
            field: 'dataHoraVencimento', headerName: 'Data Vencimento', flex: 1,
            valueGetter: (params: any) => {
                return new Date(params.value);
            },
            renderCell: (params: any) => {
                const date = new Date(params.value);
                if (isNaN(date.getTime())) {
                    return '';
                }
                return date.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });
            },
        },
        {
            field: 'status', headerName: 'Status', flex: 1, renderCell: (params: any) => {
                const status = params.row.status;
                const statusText = converterTipoStatusMultaParaTexto(status);

                let backgroundColor;
                if (status === TipoStatusMulta.Paga) {
                    backgroundColor = '#4CAF50';
                } else if (status === TipoStatusMulta.EmAberto) {
                    backgroundColor = '#FFC107';
                } else if (status === TipoStatusMulta.Vencida) {
                    backgroundColor = '#f44336';
                } else if (status === TipoStatusMulta.Cancelada) {
                    backgroundColor = '#9E9E9E';
                }

                const labelStyle: React.CSSProperties = {
                    backgroundColor,
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    textAlign: 'center' as 'center',
                };

                return (
                    <span style={labelStyle}>
                        {statusText}
                    </span>
                );
            },
            valueGetter: (params: any) => {
                const status = params.row.status;
                const statusText = converterTipoStatusMultaParaTexto(status);

                let backgroundColor;
                if (status === TipoStatusMulta.Paga) {
                    backgroundColor = '#4CAF50';
                } else if (status === TipoStatusMulta.EmAberto) {
                    backgroundColor = '#FFC107';
                } else if (status === TipoStatusMulta.Vencida) {
                    backgroundColor = '#f44336';
                } else if (status === TipoStatusMulta.Cancelada) {
                    backgroundColor = '#9E9E9E';
                }

                const labelStyle: React.CSSProperties = {
                    backgroundColor,
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    textAlign: 'center' as 'center',
                };

                return (
                    <span style={labelStyle}>
                        {statusText}
                    </span>
                );
            },
        },
        ...(empresaTemFiliais ? [{
            field: 'idFilial', headerName: 'Unidade', flex: 1,
            renderCell: (params: any) => {
                if (!params.value) return '';
                const filial = filiaisOptions.find((f: any) => f.valor === params.value);
                return filial?.label || '';
            }
        }] : []),
    ];

    const formatarDataMulta = (valor: any) => {
        const data = new Date(valor);
        return isNaN(data.getTime()) ? '' : data.toLocaleDateString("pt-BR");
    };

    const exportOptions = [
        { field: 'veiculo', headerName: 'Veículo', valueGetter: ({ row }: { row: any }) => row.veiculo ? `${row.veiculo.placa} - ${row.veiculo.marca} ${row.veiculo.modelo}` : '' },
        { field: 'locatario', headerName: 'Locatário', valueGetter: ({ row }: { row: any }) => row.locacao?.locatario?.nome ?? '' },
        { field: 'documento', headerName: 'Documento', valueGetter: ({ row }: { row: any }) => row.locacao?.locatario?.documento ?? '' },
        { field: 'descricaoInfracao', headerName: 'Descrição', valueGetter: ({ row }: { row: any }) => row.descricaoInfracao ?? '' },
        { field: 'valor', headerName: 'Valor', valueGetter: ({ row }: { row: any }) => formatarParaReais(row.valor) },
        { field: 'dataHoraCometimento', headerName: 'Data Cometimento', valueGetter: ({ row }: { row: any }) => formatarDataMulta(row.dataHoraCometimento) },
        { field: 'dataHoraVencimento', headerName: 'Data Vencimento', valueGetter: ({ row }: { row: any }) => formatarDataMulta(row.dataHoraVencimento) },
        { field: 'status', headerName: 'Status', valueGetter: ({ row }: { row: any }) => converterTipoStatusMultaParaTexto(row.status) },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', valueGetter: ({ row }: { row: any }) => filiaisOptions.find((f: any) => f.valor === row.idFilial)?.label ?? '' }] : []),
    ];

    const pages = [
        {
            titulo: "Identificação",
            campos: ["idFilial", "numeroRenainf", "autoInfracao", "codigoInfracao", "descricaoInfracao"]
        },
        {
            titulo: "Valores e Datas",
            campos: ["valor", "dataHoraCometimento", "dataHoraVencimento", "status", "naoGerarLancamentoFinanceiro", "_toggleAvancadoMulta", "_labelBancoInfoMulta", "_alertaBancosDivergentesMulta", "idBanco"]
        },
        {
            titulo: "Participantes",
            campos: ["realInfratorIndicado", "idVeiculo", "idLocacao"]
        }
    ];

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) });

    // Filtra veículos e locações pelo filial selecionado no formulário
    const veiculosFiltrados = filialNoForm
        ? veiculosRaw.filter((v: any) => !v.idFilial || v.idFilial === filialNoForm).map((v: any) => ({
            codigo: v.id, valor: v.id,
            label: labelComFilial(`${v.placa} - ${v.marca} - ${v.modelo} - ${v.ano}`, v.idFilial),
        }))
        : veiculos;

    const locacoesFiltradas = filialNoForm
        ? locacoesRaw.filter((l: any) => !l.idFilial || l.idFilial === filialNoForm).map((l: any) => ({
            codigo: l.id, valor: l.id,
            label: labelComFilial(`${l.veiculo.placa} - ${l.locatario.nome}`, l.idFilial),
        }))
        : locacoesOp;

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Identificação:', nome: '', required: false, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 6, coluna: 1, linha: 2, visible: false },
        { label: 'Número Renainf', nome: 'numeroRenainf', required: false, tipo: 'text', largura: 4, coluna: 1, linha: 2, visible: true },
        { label: 'Auto da Infração', nome: 'autoInfracao', required: false, tipo: 'text', largura: 4, coluna: 2, linha: 2, visible: true },
        { label: 'Código Infração', nome: 'codigoInfracao', required: false, tipo: 'text', largura: 4, coluna: 3, linha: 2, visible: true },

        { label: 'Detalhes da Multa:', nome: '', required: false, tipo: 'label', largura: 12, coluna: 1, linha: 3, visible: true },
        { label: 'Valor', nome: 'valor', required: true, tipo: 'money', largura: 6, coluna: 1, linha: 7, visible: true },
        {
            label: 'Status', nome: 'status', required: true, tipo: 'select', largura: 6, coluna: 2, linha: 7, visible: true,
            opcoes: [
                { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.Paga), valor: TipoStatusMulta.Paga },
                { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.EmAberto), valor: TipoStatusMulta.EmAberto },
                { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.Cancelada), valor: TipoStatusMulta.Cancelada },
                { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.Vencida), valor: TipoStatusMulta.Vencida }
            ]
        },
        { label: 'Descrição da Infração', nome: 'descricaoInfracao', required: true, tipo: 'memo', largura: 12, coluna: 1, linha: 5, visible: true, tudoMaiusculo: true },
        {
            label: 'Data/Hora Cometimento', nome: 'dataHoraCometimento', required: true, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 6, visible: true,
            onCampoDigitar(data) {
                setDataCometimentoAtual(data || '');
            },
        },
        { label: 'Data/Hora Vencimento', nome: 'dataHoraVencimento', required: false, tipo: 'datetime-local', largura: 6, coluna: 2, linha: 6, visible: true },

        { label: 'Informações Adicionais:', nome: '', required: false, tipo: 'label', largura: 12, coluna: 1, linha: 7, visible: true },
        { label: 'Real infrator indicado', nome: 'realInfratorIndicado', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 8, visible: true },
        { label: 'Não gerar lançamento financeiro', nome: 'naoGerarLancamentoFinanceiro', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 8, visible: modo == TipoFormulario.tpCadastro },
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 11, visible: true,
            opcoes: veiculosFiltrados, carregando: carregandoSelect, apenasLeitura: !campoVeiculoAtivo,
            onCampoDigitar(idVeiculo) {
                setVeiculoMultaAtual(idVeiculo || '');
            },
        },
        {
            label: 'Locação', nome: 'idLocacao', required: false, tipo: 'select', largura: 12, coluna: 1, linha: 12, visible: true,
            opcoes: locacoesFiltradas, carregando: carregandoSelect, onCampoDigitar(e) {
                if (autoPreenchendoLocacaoRef.current) {
                    autoPreenchendoLocacaoRef.current = false;
                    return; // auto-fill: não mexe no veículo nem trava o campo
                }
                if (e) {
                    const locacao = locacoes.find(l => l.id == e);
                    setEntidadeAtualizacao({ idVeiculo: locacao?.idVeiculo });
                    setForcarAtualizacao(true);
                    setCampoVeiculoAtivo(false);
                } else {
                    setCampoVeiculoAtivo(true);
                }
            },
        },
        {
            label: '', nome: '_toggleAvancadoMulta', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 90,
            component: () => (
                <button
                    type="button"
                    onClick={() => setMostrarAvancadoMulta(!mostrarAvancadoMulta)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoMulta ? 'Ocultar opções avançadas' : 'Mostrar opções avançadas'}
                </button>
            ),
        },
        {
            label: 'Atenção', nome: '_labelBancoInfoMulta', tipo: 'label', required: false,
            largura: 12, coluna: 1, linha: 91, visible: () => mostrarAvancadoMulta,
            subLabel: 'A informação do banco será aplicada aos lançamentos financeiros gerados a partir desta multa. A multa em si não armazena banco.',
        },
        {
            label: 'Atenção', nome: '_alertaBancosDivergentesMulta', tipo: 'label', required: false,
            largura: 12, coluna: 1, linha: 91, visible: () => mostrarAvancadoMulta && !!(multaSelecionado as any)?.bancosDivergentes,
            subLabel: '⚠️ Lançamentos vinculados possuem bancos distintos. Alterar aqui sobrescreverá todos.',
        },
        {
            label: 'Banco para Pagamento/Recebimento', nome: 'idBanco', tipo: 'select', required: false,
            largura: 12, coluna: 1, linha: 92, visible: () => mostrarAvancadoMulta,
            selectBoxIsCleareable: true,
            opcoes: bancosMultaOpcoes,
        },
    ];

    useEffect(() => {
        if (forcarAtualizacao) {
            setForcarAtualizacao(false);
        }
    }, [forcarAtualizacao]);

    const onSave = async (entidade: any) => {
        if (isSubmiting) return;

        if (entidade['dataHoraVencimento'] && entidade['dataHoraCometimento']) {
            if (new Date(entidade['dataHoraVencimento']) <= new Date(entidade['dataHoraCometimento'])) {
                toast.error("A data do vencimento não pode ser anterior ou igual a data de cometimento!")
                return;
            }
        }

        setIsSubmiting(true);

        if (usuarioTemPermissao(token, 'multa_novo') || usuarioTemPermissao(token, 'multa_editar')) {
            const multaASalvar: Multa = {
                DataHoraCometimento: entidade['dataHoraCometimento'] || null,
                DescricaoInfracao: entidade['descricaoInfracao'],
                idEmpresa: obterIdTenent(token),
                idVeiculo: entidade['idVeiculo'],
                RealInfratorIndicado: entidade['realInfratorIndicado'] || false,
                valor: entidade['valor'],
                AutoInfracao: entidade['autoInfracao'],
                CodigoInfracao: entidade['codigoInfracao'],
                DataHoraVencimento: entidade['dataHoraVencimento'] || null,
                idLocacao: entidade['idLocacao'] || null,
                NumeroRenainf: entidade['numeroRenainf'],
                status: entidade['status'],
                naoGerarLancamentoFinanceiro: entidade['naoGerarLancamentoFinanceiro'] || false,
                idBanco: entidade['idBanco'] || undefined,
                idFilial: entidade['idFilial'] || null,
            }

            if (modo == TipoFormulario.tpEdicao) {
                multaASalvar['id'] = entidade['id'];
            }

            const apiAcao = modo == TipoFormulario.tpCadastro ? api.post : api.put;

            apiAcao('/multa/', multaASalvar, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(response => {
                setTimeout(() => {
                    setExibirFormModal(false);
                    toast.success('Multa salva com sucesso');
                    if (modo == TipoFormulario.tpCadastro) {
                        const apenasData = multaASalvar.DataHoraCometimento.toString().split("T")[0]
                        window.location.href = `/multas?dataInicio=${apenasData}&dataFim=${apenasData}`;
                    } else {
                        setBuscar(false);
                        setBuscar(true);
                    }
                    setIsSubmiting(false);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
        }
    }

    const tratarErro = (error: AxiosError<ApiError>) => {
        setCarregando(false);
        setIsSubmiting(false);
        const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
        toast.error(`Não foi possível continuar a operação Multas: ${errorMessage}`);
    }

    const buscarLocacaoVigenteMulta = useCallback(async (idVeiculo: string, dataCometimento: string) => {
        if (!idVeiculo || !dataCometimento) return;
        try {
            const resp = await api.get(`/LocacaoVigentePorVeiculo`, {
                params: { idEmpresa: obterIdTenent(token), idVeiculo, data: dataCometimento },
                validateStatus: (s) => s === 200 || s === 204,
            });
            autoPreenchendoLocacaoRef.current = true;
            if (resp.status === 204 || !resp.data) {
                // Sem locação vigente nessa data. Só no cadastro limpamos o campo
                // (na edição não mexemos numa locação possivelmente vinculada à
                // mão). String vazia, pois o ModalForm ignora null ao aplicar.
                if (modo === TipoFormulario.tpCadastro) {
                    setEntidadeAtualizacao({ idLocacao: '' });
                    setForcarAtualizacao(true);
                }
            } else {
                setEntidadeAtualizacao({ idLocacao: resp.data.id });
                setForcarAtualizacao(true);
            }
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    }, [token, modo]);

    // Dispara a busca da locação vigente sempre que veículo E data estiverem
    // preenchidos, independente da ordem de preenchimento. Mais robusto do que
    // chamar de dentro do onCampoDigitar (que dependia de closure/ordem).
    useEffect(() => {
        if (veiculoMultaAtual && dataCometimentoAtual) {
            buscarLocacaoVigenteMulta(veiculoMultaAtual, dataCometimentoAtual);
        }
    }, [veiculoMultaAtual, dataCometimentoAtual, buscarLocacaoVigenteMulta]);

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if (modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) {
            setBuscar(false);
            setBuscar(true);
        }
    }

    const handleCadastrar = () => {
        if (usuarioTemPermissao(token, 'multa_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setFilialNoForm(filialSelecionada || null);
            setMultaSelecionado({ ...(filialSelecionada ? { idFilial: filialSelecionada } : {}) } as Multa);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar uma nova Multa');
        }
    }

    const handleEditar = async (multa: any) => {
        if (!usuarioTemPermissao(token, 'multa_editar')) {
            toast.error('Você não tem permissão para editar uma Multa');
            return;
        }
        try {
            const response = await api.get(`/Multa/${multa.id}`);
            const multaCompleta = { ...multa, ...response.data };
            setModo(TipoFormulario.tpEdicao);
            setFilialNoForm(multaCompleta.idFilial || null);
            setMultaSelecionado(multaCompleta);
            setMostrarAvancadoMulta(!!(multaCompleta as Multa).idBanco);
            setExibirFormModal(true);
        } catch (error: any) {
            tratarErro(error);
        }
    }

    const handleExclusao = (multa: Multa) => {
        if (usuarioTemPermissao(token, 'multa_excluir')) {
            setCarregando(true);
            api.delete(`/multa/${multa.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Multa foi excluída com sucesso')
                        setBuscar(false);
                        setBuscar(true);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    };

    useEffect(() => {
        const fetchLocacoes = async () => {
            setCarregandoSelect(true);
            try {
                const response = await api.get(`/LocacaoPorEmpresaSemPaginacao/${obterIdTenent(token)}`);
                const novasOpcoes = response.data.map((locacao: any) => ({
                    codigo: locacao.id,
                    valor: locacao.id,
                    label: labelComFilial(`${locacao.veiculo.placa} - ${locacao.locatario.nome}`, locacao.idFilial),
                }));
                setLocacoesOp(novasOpcoes);
                setLocacoes(response.data);
                setLocacoesRaw(response.data);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregandoSelect(false);
            }
        }
        const fetchVeiculos = async () => {
            setCarregandoSelect(true);
            try {
                const response = await api.get(`/VeiculoPorEmpresaAtivos/${obterIdTenent(token)}`);
                setVeiculosRaw(response.data);
                const novasOpcoes = response.data.map((veiculo: any) => ({
                    codigo: veiculo.id,
                    valor: veiculo.id,
                    label: labelComFilial(`${veiculo.placa} - ${veiculo.marca} - ${veiculo.modelo} - ${veiculo.ano}`, veiculo.idFilial),
                }));
                setVeiculos(novasOpcoes);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregandoSelect(false);
            }
        }
        const fetchLocatarios = async () => {
            try {
                const response = await api.get(`/LocatariosPorEmpresa/${obterIdTenent(token)}`);
                const opcoes = response.data.map((loc: any) => ({
                    valor: loc.id,
                    label: `${loc.documento} - ${loc.nome}`,
                }));
                setLocatarios(opcoes);
            } catch (error) { }
        }
        fetchLocacoes();
        fetchVeiculos();
        fetchLocatarios();
    }, [exibirFormModal])

    const handleVisualizacao = async (multa: any) => {
        if (usuarioTemPermissao(token, 'multa_visualizar')) {
            setMultaSelecionado(multa);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao);
        }
    };

    const AtualizarStatusMulta = async (idMulta: string, status: TipoStatusMulta) => {
        await api.put(`/AtualizarStatusMulta/${idMulta}/${status}`, null, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        setBuscar(false);
        setBuscar(true);

        toast.success('Status da Multa atualizado para: ' + converterTipoStatusMultaParaTexto(status))
    }

    const requisicaoBemSucedida = (response: any) => {
        setExibirFormModal(false);
        toast.success('Multa salvo com sucesso');
    }

    async function multaJaLancada(idMulta: string): Promise<boolean> {
        try {
            const response = await api.get(`/MultaLancamento/${idMulta}`);
            if (response.data.idLancamento && response.data.idLancamento != '00000000-0000-0000-0000-000000000000') {
                return true;
            } else {
                return false;
            }
        } catch (error: any) {
            tratarErro(error);
            return false;
        }
    }

    const limparParametrosUrl = () => {
        window.history.replaceState({}, '', window.location.pathname);
        setId("");
    };

    const veiculosFormatados: FiltroDropdownOpcao[] = veiculos.map(v => ({ label: v.label, value: String(v.valor) }));
    const locatariosFormatados: FiltroDropdownOpcao[] = locatarios.map(l => ({ label: l.label, value: String(l.valor) }));

    const handleBuscarMultas = async () => {
        if ((dataInicio && !dataFim) || (dataFim && !dataInicio)) {
            toast.info('Informe a Data inicial e a Data Final');
            return;
        }
        if ((dataInicio && dataFim) && diaInicialDepoisDoFinal(dataInicio, dataFim)) {
            toast.info('A Data Final deve ser Maior ou Igual a data Inicial');
            return;
        }

        if (id) {
            try {
                setCarregando(true);
                const response = await api.get(`/Multa/${id}`);
                setMultas(Array.isArray(response.data) ? response.data : [response.data]);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregando(false);
                limparParametrosUrl();
            }
            return;
        }

        const contexto: ContextoMulta = {
            idEmpresa: obterIdTenent(token),
            dataInicial: dataInicio || undefined,
            dataFinal: dataFim || undefined,
            status: Number(statusFiltro) as TipoStatusMulta,
            tipoPeriodo: tipoPeriodo === "pagamento" ? "pagamento" : "vencimento",
            idVeiculo: idVeiculoFiltro || undefined,
            idLocatario: idLocatarioFiltro || undefined,
        };

        try {
            setCarregando(true);
            const response = await api.get('/ObterTodasMultasPorContexto', { params: contexto });
            setMultas(response.data);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => {
        if (buscar) {
            handleBuscarMultas();
            setBuscar(false);
        }
    }, [buscar]);

    const configFiltros: ConfiguracaoFiltros = {
        carregando: carregando,
        aoBuscar: handleBuscarMultas,
        tipoPeriodo: tipoPeriodo,
        onChangeTipoPeriodo: setTipoPeriodo,
        datas: {
            labelInicio: "De",
            labelFim: "Até",
            dataInicio: dataInicio,
            dataFim: dataFim,
            onChangeDataInicio: setDataInicio,
            onChangeDataFim: setDataFim,
        },
        dropdowns: [
            {
                key: 'veiculo',
                label: 'Veículo',
                placeholder: 'Todos',
                multiSelect: false,
                opcoes: [{ label: 'Todos', value: '' }, ...veiculosFormatados],
                value: idVeiculoFiltro,
                onChange: (val) => setIdVeiculoFiltro(val),
            },
            {
                key: 'locatario',
                label: 'Locatário',
                placeholder: 'Todos',
                multiSelect: false,
                opcoes: [{ label: 'Todos', value: '' }, ...locatariosFormatados],
                value: idLocatarioFiltro,
                onChange: (val) => setIdLocatarioFiltro(val),
            },
            {
                key: 'status',
                label: 'Status',
                placeholder: 'Todos',
                multiSelect: false,
                opcoes: [
                    { label: 'Todos', value: String(TipoStatusMulta.Todos) },
                    { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.Paga), value: String(TipoStatusMulta.Paga) },
                    { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.EmAberto), value: String(TipoStatusMulta.EmAberto) },
                    { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.Vencida), value: String(TipoStatusMulta.Vencida) },
                    { label: converterTipoStatusMultaParaTexto(TipoStatusMulta.Cancelada), value: String(TipoStatusMulta.Cancelada) },
                ],
                value: statusFiltro,
                onChange: (val) => setStatusFiltro(val),
            },
        ],
    };

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('multa')}
                    colunas={colunas}
                    linhas={multas}
                    exportOptions={exportOptions}
                    tituloExportacao="Multas"
                    nomeEntidade="Multa"
                    nomePropriedade="descricaoInfracao"
                    carregando={carregando}
                    IconeEntidade={FaFileInvoiceDollar}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setMultaSelecionado}
                    filtros={configFiltros}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('Multa', () => { setBuscar(false); setBuscar(true); }) ? [getAcaoEmLoteFilial('Multa', () => { setBuscar(false); setBuscar(true); })!] : []),
                    ]}
                    acoesExtras={[
                        {
                            Icone: FaCheckDouble, OnClick: (multa: any) => {
                                if (multa.status != TipoStatusMulta.Paga) {
                                    AtualizarStatusMulta(multa.id, TipoStatusMulta.Paga)
                                    setBuscar(true);
                                } else {
                                    toast.info("Essa multa já está com o status de 'Paga'")
                                }
                            }, Texto: "Marcar como 'Paga'", Tamanho: 'small'
                        },
                        {
                            Icone: MdCancel, OnClick: (multa: any) => {
                                if (multa.status != TipoStatusMulta.Cancelada) {
                                    AtualizarStatusMulta(multa.id, TipoStatusMulta.Cancelada)
                                    setBuscar(true);
                                } else {
                                    toast.info("Essa multa já está com o status de 'Cancelada'");
                                }
                            }, Texto: "Marcar como 'Cancelada'",  Tamanho: 'medium'
                        },
                        {
                            Icone: AiOutlineClockCircle, OnClick: (multa: any) => {
                                if (multa.status != TipoStatusMulta.EmAberto) {
                                    AtualizarStatusMulta(multa.id, TipoStatusMulta.EmAberto)
                                    setBuscar(true);
                                } else {
                                    toast.info("Essa multa já está com o status de 'A Vencer'")
                                }
                            }, Texto: "Marcar como 'A Vencer'", Tamanho: 'medium'
                        },
                        {
                            Icone: FaMoneyBillWave, OnClick: (multa: any) => {
                                navigate.push(`/lancamento?multa=${multa.id}`);
                            }, Texto: "Ver Financeiro", Tamanho: 'small', Cor: '#2e7d32'
                        },
                        {
                            Icone: FaFileInvoice, OnClick: async (multa: any) => {
                                if (multa.status != TipoStatusMulta.Paga && multa.status != TipoStatusMulta.Cancelada) {
                                    if (!multa.idLocacao) {
                                        toast.info("Para utilizar essa opção a multa precisa ter vínculo com um Locatário")
                                        return;
                                    }
                                    if (await multaJaLancada(multa.id)) {
                                        toast.info("Já existe(m) lançamento(s) financeiro(s) para essa multa");
                                    } else {
                                        setMultaSelecionado(multa);
                                        setShowGerarLancamento(true);
                                    }
                                } else {
                                    toast.info("Não é possível gerar lançamento de uma Multa 'Paga' ou 'Cancelada'");
                                }
                            }, Texto: "Cobrar do Locatário", Tamanho: 'medium'
                        }
                    ]} />

                <ModalForm
                    urlTutorial="https://youtu.be/x9OTDda12PU"
                    pages={pages}
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    onSave={onSave}
                    isSaving={isSubmiting}
                    ajudinha={
                        {
                            texto: "Registre as multas dos seus veículos, vincule-as às locações, acompanhe os detalhes e gerencie os vencimentos com facilidade",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={multaSelecionado}
                    atualizacaoEntidade={{
                        entidadeUsadaParaAtualizacao: entidadeAtualizacao,
                        forcarAtualizacao: forcarAtualizacao
                    }}
                    apiConfig={
                        {
                            endpoint: "multa",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                />

                <ModalGerarLancamentoMulta
                    show={showGerarLancamento}
                    onClose={() => { setShowGerarLancamento(false) }}
                    entidade={multaSelecionado}
                />
            </LocaSmartLayout>
        </>
    );
}

export default MultaListagem;